import { NotificationHandlerService } from '@sit/notifications-client';

export const notificationHanderService = new NotificationHandlerService();
